/**
 * Created by yiren on 2019-09-04
 *
 */

export const CONTRACT = 'contractAddress';

export const FROM = 'fromAddress';

export const NET = 'net';

export const MAINNET = 'mainnet';

export const TESTNET = 'testnet';